import { Account } from 'src/app/shared/account/account.types';

export class AccountContextInfo {
  public id: string;
  public type: Account.Type;

  constructor(id: string, type: Account.Type) {
    this.id = id;
    this.type = type;
  }

  public static fromString(rawJson: string): AccountContextInfo {
    const accInfoRaw = JSON.parse(rawJson);
    return new AccountContextInfo(accInfoRaw.id || '', accInfoRaw.type || Account.Type.PUBLISHER);
  }

  public toString(): string {
    return JSON.stringify(this);
  }
  
}
